import Axios from 'axios';
import {
    IGetCategoriesResponse,
    IGetLoanTemplateCategoriesResponse,
    IGetStoreInfoResponse,
    IGetLoanTemplateCategoriesRequest,
    IGetStoresInfoRequest,
    IGetStoresRequest,
    IGetStoresResponse,
    IGetLoanTemplateStoresrequest,
    IGetLoanTemplateStoresResponse,
    IGetStoreProductsResponse,
    IGetStoresSections,
    IGetOnlineSearchSectionsResponse,
    IGetOfflineSearchSectionsResponse,
    IGetOnlineSearchSectionsRequest,
    IGetOfflineSearchSectionsRequest,
} from '../models/store.model';
import {ApiResultModel} from '../models/common.model';
import {APIBASE_URL, STORE_URL} from '../config/cacheKey';

export const STORE_QUERY_KEYS = {
    onlineSections: ['storeSections', 'online'] as const,
    offlineSections: ['storeSections', 'offline'] as const,
    allSections: ['storeSections'] as const,
    sectionItems: (sectionItemsKey: string) =>
        ['sectionItems', sectionItemsKey] as const,
} as const;

export const STALE_10_MIN = 10 * 60 * 1000;

export const GetCategories = async (data: {
    walletKey?: string;
}): Promise<IGetCategoriesResponse[]> => {
    return await Axios.post<ApiResultModel<IGetCategoriesResponse[]>>(
        APIBASE_URL + STORE_URL + '/GetCategories',
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const GetAllCategories = async (data: {
    walletKey?: string;
}): Promise<IGetCategoriesResponse[]> => {
    return await Axios.post<ApiResultModel<IGetCategoriesResponse[]>>(
        APIBASE_URL + STORE_URL + '/GetAllCategories',
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const GetStores = async (
    data: IGetStoresRequest
): Promise<IGetStoresResponse> => {
    return await Axios.post<ApiResultModel<IGetStoresResponse>>(
        APIBASE_URL + STORE_URL + '/GetStores',
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const GetStoreInfo = async (
    data: IGetStoresInfoRequest
): Promise<IGetStoreInfoResponse> => {
    return await Axios.post<ApiResultModel<IGetStoreInfoResponse>>(
        APIBASE_URL + STORE_URL + '/GetStoreInfo',
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const GetLoanTemplateCategories = async (
    data: IGetLoanTemplateCategoriesRequest
): Promise<IGetLoanTemplateCategoriesResponse[]> => {
    return await Axios.post<
        ApiResultModel<IGetLoanTemplateCategoriesResponse[]>
    >(APIBASE_URL + STORE_URL + '/GetLoanTemplateCategories', data).then(
        (result) => {
            return result.data.data;
        }
    );
};
export const GetLoanTemplateStores = async (
    data: IGetLoanTemplateStoresrequest
): Promise<IGetLoanTemplateStoresResponse> => {
    return await Axios.post<ApiResultModel<IGetLoanTemplateStoresResponse>>(
        APIBASE_URL + STORE_URL + '/GetLoanTemplateStores',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const GetStoreProducts = async (data: {
    storeId: number;
}): Promise<IGetStoreProductsResponse[]> => {
    return await Axios.post<ApiResultModel<IGetStoreProductsResponse[]>>(
        APIBASE_URL + STORE_URL + '/GetStoreProducts',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const GetOnlineStoresSections = async (): Promise<
    IGetStoresSections[]
> => {
    return await Axios.post<ApiResultModel<IGetStoresSections[]>>(
        APIBASE_URL + STORE_URL + '/GetOnlineStoresSections',
        {}
    ).then((result) => {
        return result.data.data;
    });
};

export const GetOfflineStoresSections = async (): Promise<
    IGetStoresSections[]
> => {
    return await Axios.post<ApiResultModel<IGetStoresSections[]>>(
        APIBASE_URL + STORE_URL + '/GetOfflineStoresSections',
        {}
    ).then((result) => {
        return result.data.data;
    });
};
export const GetSectionItems = async ({
    sectionItemsKey,
}: {
    sectionItemsKey: string;
}): Promise<IGetStoreProductsResponse[]> => {
    return await Axios.post<ApiResultModel<IGetStoreProductsResponse[]>>(
        APIBASE_URL + STORE_URL + '/GetSectionItems',
        {sectionItemsKey}
    ).then((result) => {
        return result.data.data;
    });
};

export const getOnlineSearchSections = async (
    data: IGetOnlineSearchSectionsRequest
): Promise<IGetOnlineSearchSectionsResponse[]> => {
    return await Axios.post<ApiResultModel<IGetOnlineSearchSectionsResponse[]>>(
        APIBASE_URL + STORE_URL + '/GetOnlineSearchSections',
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const getOfflineSearchSections = async (
    data: IGetOfflineSearchSectionsRequest
): Promise<IGetOfflineSearchSectionsResponse[]> => {
    return await Axios.post<
        ApiResultModel<IGetOfflineSearchSectionsResponse[]>
    >(APIBASE_URL + STORE_URL + '/GetOfflineSearchSections', data).then(
        (result) => {
            return result.data.data;
        }
    );
};
